import React, { useState, useContext, useEffect } from 'react';

import { FormTextInput } from '../../Components/FormTextInput';

import { useScreenTransition } from '../../Hooks/useScreenTransition';

import { AuthContext } from '../../Context/AuthContext';
import { TransitionContext } from '../../Context/TransitionContext';
import { DataContext } from '../../Context/DataContext';
import { NotificationContext } from '../../Context/NotificationContext';

import { useEnterKey } from '../../Hooks/useEnterKey';

import TopBar from '../../Components/TopBar';
import {ReactComponent as CAMERA} from "../../assets/icons/camera.svg";
import {ReactComponent as EDIT} from "../../assets/icons/Edit.svg";
import NewButton from '../../NewComponents/NewButton';
import UploadImgPopUp from '../../NewComponents/UploadImgPopUp';
import AccountNavBar from '../../NewComponents/AccountNavBar';
import './Profile.css';
import { auth, firestore } from '../../firebase.config';

const Profile = ({ windowSize }) => {

  const { transitionTo } = useScreenTransition();

  const { setColor } = useContext(TransitionContext);
  const { userData } = useContext(DataContext);
  console.log("userData--> ",userData);
  const { signedIn } = useContext(AuthContext);
  const { showNotification } = useContext(NotificationContext);

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('+1 ');
  const [infoButton, setInfoButton] = useState('Save');

  const [profilePic, setProfilePic] = useState();

  const [showEditPopUp, setShowEditPopUp] = useState(false);
  const [showPopUp, setShowPopUp] = useState(false);
  const [imgLoaded, setImgLoaded] = useState(false);


 

  useEffect(() => {
    if (userData) {
      if (userData.firstName) {
        setFirstName(userData.firstName);
        setLastName(userData.lastName || '');
      } else if (userData.name) {
        const nameParts = userData.name.trim().split(' ');
        setFirstName(nameParts[0]);
        setLastName(nameParts.slice(1).join(' '));
      } else {
        setFirstName('');
        setLastName('');
      }
  
      setEmail(userData.email || '');
      setPhone(userData.phone || '(+1) ');
      setProfilePic(userData.profilePic);
    }
  }, [userData]);
  


  useEffect(() => {
    setColor(true);
  }, [setColor]);

  useEffect(() => {
    if (!signedIn) {
      transitionTo('/');
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signedIn]);

  const handleSaveInfo = () => {
    setInfoButton("Saving...")
    if (firstName !== '' && email !== '') {
      setInfoButton('Saving...');
  
      firestore.collection('users').doc(auth.currentUser.uid)
        .update({
          name: lastName !== "" ? (firstName + " " + lastName) : firstName,
          firstName: firstName,
          lastName: lastName !== "" ? lastName : "",
          phone: phone
        })
        .then(() => {
          showNotification('Information Saved', 'Your information has been saved successfully.', 'success');
          setInfoButton('Save');
        })
        .catch(error => {
          setInfoButton('Save');
          showNotification('Error', 'An error occurred when saving your information. Please, try again. If it persists, contact Support.', 'error');
        })
    }
  }

  useEnterKey(() => handleSaveInfo());

  const checkBtnDisabled = () => {
    if(infoButton === "Saving..." || firstName === "" || (userData && 
      (userData.name === firstName || userData.firstName === firstName) &&
      (lastName ? userData.lastName === lastName : true) && (phone ? userData.phone === phone : true)
    )){
        return true;
      }else{
        return false;
      }
  } 

  const getFirstTwoLetters = () => {
    let twoLetters = "U";
    if (signedIn && userData) {
      if (userData.firstName) {
        twoLetters = userData.firstName[0] + (userData.lastName ? userData.lastName[0] : userData.firstName[1]);
      } else {
        twoLetters = userData.name ? userData.name.slice(0, 2) : "U";
      }
    }
    return twoLetters.toUpperCase();
  };

  const imgStyle = profilePic ? {transform: `scale(${profilePic.scale})`, top: profilePic.top , left: profilePic.left, opacity: imgLoaded ? 1: 0} : {};

  const handleEditProfile = (e) => {
    setShowEditPopUp(true);
    setShowPopUp(true);
  }

  const handleUpdateProfile = (e) => {
    setShowPopUp(true);
  }


  return (
    <>
      <TopBar/>
      {showPopUp && <UploadImgPopUp setShowPopUp={setShowPopUp} profileEdit={showEditPopUp} setProfileEdit={setShowEditPopUp}  windowSize={windowSize}/>}

      <AccountNavBar windowSize={windowSize} selectedTab="profile">
        <div className="accountMainTitleRow">
          <h2 className="accountMainTitle">My Profile</h2>
        </div>
        {signedIn && profilePic && profilePic.url ? (
          <div className="accountMainProfileImgContainer">
            <div className="accountMainProfileImgWrap">
              {!imgLoaded && (
                <div className="accountMainProfileImgText">
                  {getFirstTwoLetters()}
                </div>
              )}
              <img
                className="accountMainProfileImg"
                width={"100%"}
                style={imgStyle}
                src={profilePic.url}
                alt=""
                onLoad={() => setImgLoaded(true)}
              />
            </div>
            <div
              className="accountMainProfileEditImg"
              onClick={handleEditProfile}
            >
              <EDIT className="accountMainProfileEditImgIcon" />
            </div>
          </div>
        ) : (
          <div className="accountMainProfileImgContainer">
            <div className="accountMainProfileImgWrap">
              <div className="accountMainProfileImgText">
                {getFirstTwoLetters()}
              </div>
            </div>
            <div
              className="accountMainProfileEditImg"
              onClick={handleUpdateProfile}
            >
              <CAMERA className="accountMainProfileEditImgIcon" />
            </div>
          </div>
        )}
          
        <div className="accountProfileForm">
          <div className="accountProfileFormWrap">
            <FormTextInput placeholder="First Name" value={firstName} onChange={setFirstName} />
            <FormTextInput placeholder="Last Name" value={lastName} onChange={setLastName} />
          </div>
          <div className="accountProfileFormWrap">
            <FormTextInput disabled={true} placeholder="Email(*)" value={email} onChange={setEmail} notAllow/>
            <FormTextInput placeholder="Phone Number" value={phone} onChange={setPhone} showCountryCode/>
          </div>
        </div>

        <NewButton text={infoButton} onClick={() => handleSaveInfo()} width="120px" disabled={checkBtnDisabled()}/>

      </AccountNavBar>
    </>
  );
}

export default Profile;